import React,{useState} from 'react';
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from "react-select";
import loader from "../../assets/Images/loader.gif";
import { StyledEngineProvider } from "@mui/material/styles";
// import dayjs from "dayjs";
import { DemoContainer , DemoItem } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDateTimePicker } from "@mui/x-date-pickers/MobileDateTimePicker";

const optionStatus=[
{ label: "Select Option", value: "0" },
{ label: "Positive", value: "1" },
{ label: "Negative", value: "2" },
{ label: "Scheduled Appointment", value: "3" }];

const optionAppointment=[
{ label: "Select Option", value: "0" },
{ label: "Meeting", value: "1" },
{ label: "Phone Call", value: "2" },
]

const FLRcreateCaf = () => {
  const style = {
    control: (base) => ({
      ...base,
      border: 0,
      // This line disable the blue border
      boxShadow: "none",
    }),
  };
    const [loading, setLoading] = useState(false);
    const [selectStatus, setSelectStatus] = useState(optionStatus[0]);
    const [selectAppointment,setSelectAppointment]=useState(optionAppointment[0]);
    const [selectedDateTime, setSelectedDateTime] = useState(null);
    const [userLeadData, setUserLeadData] = useState({
        estimateClouseDate: "",
        remark:"",
        preferDateTime:"",
    })
    

    const handleChange = (e) => {
        // console.log(e.target.name,e.target.value);
        setUserLeadData({ ...userLeadData, [e.target.name]: e.target.value });
      };
    const handleSelectStatus =(status)=>{
        setSelectStatus(status);
    }
    const handleSelectAppointment=(appointment)=>{
        setSelectAppointment(appointment);
    }

    const handleDateTimeChange = (dateTime) => {
      setSelectedDateTime(dateTime);
      // console.log("setSelectedDateTime :",setSelectedDateTime)
    };

    const formatDateString=(dateString)=> { 
        if(leadId === null){
          return dateString
        }
        else if(dateString.indexOf("-") === 4){
          return dateString
        }
        else if(dateString.indexOf("-") === 2){
          const [day, month, year] = dateString.split("-");
        return `${year}-${month}-${day}`;
        }
        else{
        // Assuming dateString is in the format DD-MM-YYYY
        const [day, month, year] = dateString.split("-");
        return `${year}-${month}-${day}`;
        }
      }


  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const leadId = searchParams.get("LeadId");
  const value=`FLR for Lead ${leadId}`
  const mobileNo = searchParams.get('mobileNo');

//   console.log("mobileNo",mobileNo)

const handleSubmit = async () => {
    try {
        setLoading(true)
    const apiUrl = process.env.REACT_APP_API_URL;
    const requestData = {
      Action: "updateFLR",
      Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
      appointmentflr:  selectAppointment.value,
      estimatedclosureflr: formatDateString(userLeadData.estimateClouseDate),
      leadId: leadId,
      mobilephoneflr: mobileNo, 
      password: sessionStorage.getItem("password"),
      prefereddatetimeflr: selectedDateTime ? selectedDateTime : "",
      remarkflr: userLeadData.remark,
      statusflr: selectStatus.value,
      userName: sessionStorage.getItem("userName"),
    };
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData),
      });
      const data = await response.json();
      // console.log("API Response flr create:", data);
      if(data.StatusCode==="200"){
        toast.success("FLR Updated Successfully", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
          navigate(`/businessLeadForm?LeadId=${leadId}`);
      }else{
        toast.warning(data.Response.Message, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
      }
      setLoading(false);
    } catch (error) {
      console.error('Error during API call:', error);
    }
  };
  

    const navigate = useNavigate();
    const redirectLeadDetailsPage=()=>{
    navigate(`/businessLeadForm?LeadId=${leadId}`);
  }
  return (
    <>
        <div className="container-fluid text-light Header-style header">
        <div className="p-3">
          <span
            className=""
            style={{ cursor: "pointer" }}
            onClick={redirectLeadDetailsPage}
          >
            <i className="fa-solid fa-arrow-left-long"></i>
          </span>
          <span className="p-1 m-2">FLR</span>
        </div>
      </div>    


      {loading ? (
        <div className="loader-wrapper">
          <div className="loader">
            <img src={loader} alt="loading...."></img>
          </div>
        </div>
      ) : (
    <div className='container-fluid form-container'>
      <div className="container shadow mb-3 bg-body rounded">
              <form className="contact-form p-2">
                <div className="input-box form-floating ">
                  <input
                    type="text"
                    placeholder="Enter Mobile Number"
                    className=" form-control input-text form-control-sm mt-1"
                    id="subject"
                    name="subject"
                    value={value}
                    readOnly={true}
                    // onChange={handleSubject}
                    style={{ background: 'transparent' }} 
                    
                  />
                  <label htmlFor="floatingInput" className='mt-2'>Subject</label>
                </div>

                {/* {console.log("status",selectStatus.value)} */}

                <div className="">
                  <label className="select-search-label mt-1">
                  Status
                  </label>
                  <Select
                    className=" basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="select"
                    placeholder="Select"
                    styles={style}
                    value={selectStatus}
                    isSearchable={false}
                    onChange={handleSelectStatus}
                    options={optionStatus.map((data) => ({
                      value: data.value,
                      label: data.label,
                    }))}
                  />
                </div>

                

                {selectStatus.value && selectStatus.value=="1" ? (
                <div className="input-box form-floating ">
                  <input
                    type="date"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="estimateClouseDate"
                    name="estimateClouseDate"
                    value={formatDateString(userLeadData.estimateClouseDate)}
                    onChange={handleChange}
                    // min={getCurrentDate()}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    Estimated Closure Date
                  </label>
                </div>): null}

                {selectStatus.value && selectStatus.value=="2" ? (
                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="remark"
                    name="remark"
                    value={userLeadData.remark}
                    onChange={handleChange}
                  />
                  <label htmlFor="floatingInput" className='mt-2'>Remarks</label>
                </div>):null}
                
                {selectStatus.value && selectStatus.value=="3" ? (
                
                <div className="">
                  <label className="select-search-label mt-1">
                  Appointment
                  </label>
                  <Select
                    className=" basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="select"
                    placeholder="Select"
                    styles={style}
                    value={selectAppointment}
                    isSearchable={false}
                    onChange={handleSelectAppointment}
                    options={optionAppointment.map((data) => ({
                      value: data.value,
                      label: data.label,
                    }))}
                  />
                </div>
                ): null}
                
                {selectStatus.value && selectStatus.value=="3" ? (
                
                <div>
              <label className="select-search-label mt-1">Prefer Date & Time</label>
              <StyledEngineProvider>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["MobileDateTimePicker"]}>
                    <MobileDateTimePicker
                      value={selectedDateTime}
                      onChange={handleDateTimeChange}
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </StyledEngineProvider>
              </div>
                ):null}

                
            </form>
        </div>
    

        <div className=" text-center mt-5 mb-3">
            <button
              type="submit"
              className="btn text-light submit-btn bg-dark mx-auto rounded-pill"
              onClick={handleSubmit}
            >Save</button>
        </div>
    </div>)}
    </>
  )
}

export default FLRcreateCaf;
